import { Button, Checkbox, FormControl, FormControlLabel, Grid, Menu, MenuItem } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { ArrowDropDown, FilterList } from "@material-ui/icons";
import React from "react";

const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      flex: "auto",
    },
    spacingFilter: {
      marginRight: 0,
    },
    label: {
      color: "#399ebf",
      display: "flex",
      alignItems: "center",
    },
  })
);

interface OptionFilter {
  label: string;
  value: any;
}

export interface RecapFilterProps {
  filterLabel: any;
  options?: Array<OptionFilter>;
  getCheckedOption?: (checkedOption: string) => void;
  fullWidth?: boolean;
  backgroundColor?: string;
  filterWithDropDownIcon?: boolean;
}

export default function FilterCheckbox({
  filterLabel,
  options = [],
  getCheckedOption,
  fullWidth = false,
  backgroundColor = "",
  filterWithDropDownIcon = false,
}: RecapFilterProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl);
  const styles = useStyles();
  const handleFilter = (option: string) => {
    getCheckedOption(option);
  };

  const renderOptions = () =>
    options.map((option) => (
      <MenuItem key={option.value}>
        <FormControlLabel
          value={option.value}
          control={<Checkbox color="primary" />}
          label={option.label}
          labelPlacement="end"
        />
      </MenuItem>
    ));
  return (
    <Grid item className={styles.spacingFilter}>
      <Button
        aria-label="more"
        aria-controls="customized-menu"
        aria-haspopup="true"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        variant="outlined"
        endIcon={filterWithDropDownIcon ? <ArrowDropDown style={{ fontSize: 32 }} /> : <FilterList color="primary"/>}
        style={{ width: fullWidth ? "100%" : "auto", backgroundColor, height: 55, border: "0.5px solid #399ebf" }}
      >
        <div className={styles.label}>{filterLabel}</div>
      </Button>

      <Menu id="filter-menu" anchorEl={anchorEl} keepMounted open={open1} onClose={() => setAnchorEl(null)}>
        <FormControl
          onChange={(e: any) => handleFilter(e.target.value)}
          component="fieldset"
          className={styles.formControl}
        >
          {renderOptions()}
        </FormControl>
      </Menu>
    </Grid>
  );
}
